var _path, _path2, _path3, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscuss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02139 1.50274C11.8977 1.50274 15.0401 4.64512 15.0401 8.52146C15.0401 10.5513 15.0386 11.9887 14.9209 13.0481C14.8024 14.1149 14.584 14.5783 14.3311 14.8312C14.0783 15.084 13.6148 15.3024 12.548 15.421C11.4886 15.5387 10.0512 15.5402 8.02139 15.5402C4.14506 15.5402 1.00267 12.3978 1.00267 8.52146C1.00267 4.64513 4.14506 1.50274 8.02139 1.50274Z",
    stroke: "white",
    strokeWidth: 2.00535
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.508 8.56149C10.508 2.98662 10.508 2.98662 16.0829 2.98662C19.1618 2.98662 21.6578 5.48257 21.6578 8.56149C21.6578 11.6404 19.1618 14.1364 16.0829 14.1364C13.004 14.1364 10.508 11.6404 10.508 8.56149Z",
    fill: "#E39F1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85829 7.07749C6.52604 7.07749 6.25669 7.34684 6.25669 7.6791H4.25134C4.25134 6.23932 5.41851 5.07214 6.85829 5.07214C8.29807 5.07214 9.46525 6.23932 9.46525 7.6791C9.46525 8.78462 8.76564 9.70038 7.82086 10.0876V10.2459H5.81551V9.28337C5.81551 8.72961 6.26443 8.2807 6.81819 8.2807C7.18281 8.2807 7.4599 7.97953 7.4599 7.6791C7.4599 7.34684 7.19055 7.07749 6.85829 7.07749Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.81549,
    y: 10.607,
    width: 2.00535,
    height: 1.36364,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0802,
    y: 10.6872,
    width: 2.00535,
    height: 1.36364,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0802,
    y: 5.23257,
    width: 2.00535,
    height: 4.97326,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscuss);
export default __webpack_public_path__ + "static/media/discuss.0cd7e8bc510de832a8b9e7433d6a5419.svg";
export { ForwardRef as ReactComponent };